import { useState, type ReactNode } from 'react';
import styles from './ConfirmButton.module.css';

export interface ConfirmButtonProps {
  label: ReactNode;
  confirmLabel: string;
  onConfirm: () => void;
  busy?: boolean;
  className?: string;
  prompt?: string;
}

export function ConfirmButton(props: ConfirmButtonProps) {
  const { label, confirmLabel, onConfirm, busy = false, className = 'btn btn-danger-outline', prompt = 'ARE YOU SURE?' } = props;
  const [asking, setAsking] = useState(false);
  if (!asking) {
    return <button type="button" className={className} disabled={busy} onClick={() => setAsking(true)}>{label}</button>;
  }
  return (
    <span className={styles.confirm} role="group" aria-label={prompt}>
      <span className={styles.prompt}>{prompt}</span>
      <button type="button" className="btn btn-hot" onClick={() => { setAsking(false); onConfirm(); }}>{confirmLabel}</button>
      <button type="button" className="btn btn-outline" onClick={() => setAsking(false)}>CANCEL</button>
    </span>
  );
}
